import { IonButton, IonButtons, IonCol, IonContent, IonFooter, IonGrid,
  IonHeader, IonIcon, IonInput, IonModal, IonPage, IonRow, IonTitle, IonToolbar } from '@ionic/react';
 
import './Page.css';

import { useEffect, useRef, useState } from 'react';
import { _appVersion, _defaultButtonColor, _dict, _host, _lang, _pathSeparator, _testMode, _urls, firebaseConfig } from '../components/constants';
import { auth, isInAppBrowser, sendLoginErrors, SignInWithEmailPass, SignInWithFacebook, SignInWithGoogle, SignInWithGooglePopup } from '../components/Auth';
import { sendEmailVerification, createUserWithEmailAndPassword, getAuth, getRedirectResult, sendPasswordResetEmail, onAuthStateChanged, User } from "firebase/auth";
import { useGlobalStore } from '../components/stateManagement/globalZustand';
import { useUserStore } from '../components/stateManagement/userZustand';
import { arrowBack, arrowForward, home, homeOutline, logoFacebook, logoGoogle } from 'ionicons/icons';
import { logMe } from '../foo/user';
import { useHistory } from 'react-router';
import { useURLStore } from '../components/stateManagement/URLZustand';
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import LoginChecklistDialog from '../components/dialogs/LoginChecklistDialog';
import BrowserWarning from '../components/BrowserWarning';

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

const Login: React.FC = () => {
  const [showLoading, setShowLoading] = useState(true);
  const { lang } = useGlobalStore();
  const { doLogin } = useUserStore();
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [doRecovery, setDoRecovery] = useState(false);
  const [passwordResetSent, setPasswordResetSent] = useState(false);
  const [sentRegistrationEmail, setSentRegistrationEmail] = useState(false);
  const [showEmPswFields, setShowEmPswFields] = useState(false);
  const [showLoginChecklist, setShowLoginChecklist] = useState(false);
  
  const modal = useRef<HTMLIonModalElement>(null);
  
  const { getURLTo } = useURLStore();
  const history = useHistory();


  

  const getRedirectAuthResults = async (result: any) => {
    if (result !== null) {
      if (result?.user.uid !== undefined && result?.user.uid !== null) {
        setShowLoading(true);
        await doLogin(result?.user.uid, result?.user.email);
        setShowLoading(false);
        logMe("login_success");
        history.push(getURLTo().home());
      } else {
        const errorMsg = "Google login credentials are undefined.";
        const otherErrors = sendLoginErrors(errorMsg, email);
        if (otherErrors !== undefined) {
          setErrorMessage(errorMsg + " " + otherErrors);
        } else {
          setErrorMessage(errorMsg);
        }
      }
    }
  };
  
  
  useEffect(() => {
    getRedirectResult(auth)
      .then(async (result: any) => {
        await getRedirectAuthResults(result);
      })
      .catch((error) => {
        logMe("login_failed", { method: "google", reason: JSON.stringify(error) });
        let errors = error.message;
        const otherErrors = sendLoginErrors(error, email);
        if (otherErrors !== undefined) {
          errors += " " + otherErrors;
        }
        setErrorMessage(errors);
      })
      .finally(() => {
        setShowLoading(false);
      });
    logMe("login_load");

    //return () => unsubscribe();
  }, []);
  

  const handleEmailPasswordLogin = async () => {
    try {
      const result = await SignInWithEmailPass(email || "", password || "");
      if (result?.user.uid !== undefined && result?.user.uid !== null && result?.user.email !== undefined && result?.user.email !== null) {
        setShowLoading(true);
        await doLogin(result?.user.uid, result?.user.email);
        setShowLoading(false);
        logMe("login_failed", { method: "emailPassword" });
        history.push(getURLTo().home());
      } else {
        let errors = "Email/Password login credentials are undefined.";
        const otherErrors = sendLoginErrors(errors);
        if (otherErrors !== undefined) {
          errors += " " + otherErrors;
        }
        setErrorMessage(errors);
      }
    } catch (error) {
      logMe("login_failed", { method: "emailPassword", reason: JSON.stringify(error) });
      const otherErrors = sendLoginErrors(error, email);
      if (otherErrors !== undefined) {
        setErrorMessage(errorMessage + " " + otherErrors);
      } else {
        setErrorMessage((error as Error).toString());
      }
    }
  };

  const handleRegister = async () => {
    const auth = getAuth();
    auth.languageCode = lang;
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      sendEmailVerification(user).then(() => {
        setErrorMessage("");
        setSentRegistrationEmail(true);
      });
    } catch (error) {
      const errMsg = (error as Error).toString();
      const otherErrors = sendLoginErrors(errMsg, email);
      if (otherErrors !== undefined) {
        setErrorMessage(errMsg + " " + otherErrors);
      } else {
        setErrorMessage(errMsg);
      }
    }
  };

  const handlePasswordReset = async () => {
    const auth = getAuth();
    auth.languageCode = lang;
    try {
      await sendPasswordResetEmail(auth, email);
      setErrorMessage("");
      setPasswordResetSent(true);
    } catch (error) {
      const errMsg = (error as Error).toString();
      const otherErrors = sendLoginErrors(errMsg, email);
      if (otherErrors !== undefined) {
        setErrorMessage(errMsg + " " + otherErrors);
      } else {
        setErrorMessage(errMsg);
      }
    }
  };

  useEffect(() => {
    if (errorMessage?.toLowerCase().includes("already-in-use") || errorMessage?.toLowerCase().includes("undefined")) {
      if (doRecovery !== true) {
        setDoRecovery(true);
      }
    }
  }, [errorMessage]);

  if (showLoading) {
    return (
      <IonPage>
        <IonContent fullscreen className="ion-text-center" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <h2>{_dict.loading[lang]}</h2>
          {errorMessage && <p>{errorMessage}</p>}
        </IonContent>
      </IonPage>
    );
  }

  if (isInAppBrowser()) {
    return <BrowserWarning />;
  }

  const handleNavigation = (url: string) => {
    window.location.href = url;
  };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
        <IonButtons slot="start">
            <IonButton onClick={() => {history.push(getURLTo().home());}}>
              <IonIcon slot="icon-only" icon={home} />
            </IonButton>
          </IonButtons>
          <IonTitle>
            
            <IonGrid>
              <IonRow>
                <IonCol></IonCol>
                <IonCol className="ion-text-center">{_dict.login[lang]}</IonCol>
                <IonCol></IonCol>
              </IonRow>
            </IonGrid>
            

            {errorMessage && (
              <div style={{ color: "red", textAlign: "center" }}>
                {_dict.error[lang]}:{" "}
                {errorMessage.toLowerCase().includes("already-in-use")
                  ? _dict.accountAlreadyExists[lang]
                  : errorMessage?.toLowerCase().includes("invalid-email")
                  ? _dict.invalidEmail[lang]
                  : errorMessage?.toLowerCase().includes("missing-password")
                  ? _dict.missingPassword[lang]
                  : errorMessage?.toLowerCase().includes("undefined")
                  ? _dict.undefinedAccount[lang]
                  : errorMessage?.toLowerCase().includes("weak-password")
                  ? _dict.weakPassword[lang]
                  : errorMessage?.toLowerCase().includes("user-not-found")
                  ? _dict.userNotFound[lang]
                  : errorMessage?.toLowerCase().includes("account-exists")
                  ? _dict.accountExistsWithDifferentProvider[lang]
                  : errorMessage}
              </div>
            )}
            {passwordResetSent && (
              <div style={{ color: "green", textAlign: "center" }}>{_dict.passwordResetSent[lang]}</div>
            )}
            {sentRegistrationEmail && (
              <div style={{ color: "green", textAlign: "center" }}>{_dict.sentRegistrationEmail[lang]}</div>
            )}
          </IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonGrid>
          <IonRow>
            <IonCol className="ion-text-center" style={{ marginBottom: "10px" }}>
              {_dict.loginMessage[lang]}
            </IonCol>
          </IonRow>
          { showEmPswFields === false &&
          (<>
          {/*
          <IonRow>
            <IonCol></IonCol>
            <IonCol className="ion-text-center">
              <IonButton fill="outline" expand="block" onClick={async () => {setShowLoading(true); SignInWithGoogle()}}>
                {_dict.loginWithGoogle[lang]}
                <IonIcon slot="end" icon={logoGoogle} />
              </IonButton>
              <div style={{fontStyle:"italic"}}>({_dict.suggested[lang]})</div>
            </IonCol>
            <IonCol></IonCol>
          </IonRow>
          <IonRow>
            <IonCol className="ion-text-center">{_dict.or[lang]}</IonCol>
          </IonRow>*/
          }

          <IonRow>
            <IonCol></IonCol>
            <IonCol className="ion-text-center">
              <IonButton fill="outline" expand="block" size="large" onClick={async () => {setShowLoading(true); getRedirectAuthResults(await SignInWithGooglePopup())}}>
                {/*_dict.loginWithGooglePopup[lang]*/ _dict.loginWithGoogle[lang]}
                <IonIcon slot="end" icon={logoGoogle} />
              </IonButton>
            </IonCol>
            <IonCol></IonCol>
          </IonRow>
          <IonRow>
            <IonCol className="ion-text-center">{_dict.or[lang]}</IonCol>
          </IonRow>
          <IonRow>
            <IonCol></IonCol>
            <IonCol className="ion-text-center">
              <IonButton fill="solid" size="large"
              expand="block"
              onClick={async () => {setShowLoading(true); SignInWithFacebook()}}
              style={{"--background":_defaultButtonColor}}>
                {_dict.loginWithFacebook[lang]}
                <IonIcon slot="end" icon={logoFacebook} />
              </IonButton>
            </IonCol>
            <IonCol></IonCol>
          </IonRow>
         </>)}
          
          {showEmPswFields && (<IonRow>
            <IonCol></IonCol>
            <IonCol>
              <IonInput fill="solid" placeholder="Email" onIonInput={(e) => setEmail(e.detail.value || "")} />
              <IonInput fill="solid" placeholder="Password" type="password" onIonInput={(e) => setPassword(e.detail.value || "")} />
              <IonButton
                disabled={email.length === 0 || password.length === 0}
                fill="outline"
                expand="block"
                size="large"
                onClick={handleEmailPasswordLogin}
              >
                {_dict.loginWithEmailAndPassword[lang]}
              </IonButton>
              <div className="ion-text-center">
                {_dict.orIfItIsTheFirstTime[lang]}:
              </div>

              <IonButton
                disabled={email.length === 0 || password.length === 0}
                fill="outline"
                expand="block"
                size="large"
                onClick={handleRegister}
              >
                {_dict.register[lang]}
              </IonButton>
              {doRecovery && (
                <IonButton  fill="outline" expand="block" onClick={handlePasswordReset}>
                  {_dict.resetPassword[lang]}
                </IonButton>
              )}
            </IonCol>
            <IonCol></IonCol>
          </IonRow>)}
          <IonRow>
            <IonCol className="ion-text-center">{_dict.or[lang]}</IonCol>
          </IonRow>
          <IonRow>
            <IonCol></IonCol>
            <IonCol className="ion-text-center">
              <IonButton  fill="solid" color="dark"
              size="large"
              expand="block" onClick={() => setShowEmPswFields(!showEmPswFields)}>
                <IonIcon icon={showEmPswFields ? arrowBack : arrowForward} slot={showEmPswFields ? "start" : "end"}/>
                {showEmPswFields ? _dict.quickAccessWithGoogleOrFacebook[lang] : _dict.accessWithEmailAndPassword[lang]}
              </IonButton>
            </IonCol>
            <IonCol></IonCol>
          </IonRow>

          <IonRow className="ion-align-items-center">
          <IonCol className="ion-text-center ion-align-items-center">
            <div style={{display:"flex", flexDirection:"row", alignItems:"center", justifyContent:"center"}}>
              {_dict.inCaseOfProblemsContactUs[lang]}{" "}
              <IonButton fill="clear" onClick={()=>history.push("/report")} >
                {_dict.here[lang]}
              </IonButton>
              {" "}
              {_dict.orOn[lang]}
              <IonButton fill="clear" href="https://www.facebook.com/dsapp.comunicare" target="_blank">
                Facebook
              </IonButton>
            </div>
          </IonCol>
        </IonRow>
        </IonGrid>


        
      </IonContent>
      <div style={{ position: 'fixed', background:"white",
      color: "black", bottom: 0, width: '100%', textAlign: 'center',
       }}>
        <img src="assets/icon/icon_round.png" height={"50px"} alt="Logo"
        onClick={() => {history.push(getURLTo().home());}}
        />
        <div>DSApp v{_appVersion}</div>
      </div>
    </IonPage>
  );
};

export default Login;
